module.exports = __webpack_public_path__ + "img/alxq4.1340f7f1.png";